// Intervention catalog (categories, items, durations)
export const CATS = {
  "Higiene y cuidado": {
    color: "#2563EB",
    bg: "#DBEAFE",
    items: [
      { n: "Bano general en cama", d: 30 },
      { n: "Bano asistido en regadera/tina", d: 20 },
      { n: "Higiene bucal", d: 10 },
      { n: "Aseo perineal / Higiene de genitales", d: 15 },
      { n: "Cambio de ropa de cama", d: 15 },
      { n: "Cambio de ropa del paciente", d: 10 },
      { n: "Cuidado del cabello", d: 10 },
      { n: "Afeitado asistido", d: 10 },
      { n: "Cuidado de unas", d: 15 },
      { n: "Aplicacion de crema hidratante", d: 10 },
    ],
  },
  "Monitoreo": {
    color: "#0F6E56",
    bg: "#D1FAE5",
    items: [
      { n: "Toma de signos vitales completos", d: 10 },
      { n: "Control glucometrico", d: 5 },
      { n: "Balance hidrico y monitoreo de diuresis", d: 10 },
      { n: "Valoracion de dolor (EVA)", d: 5 },
      { n: "Valoracion neurologica (Glasgow/MMSE)", d: 10 },
      { n: "Pesaje y registro de peso", d: 10 },
      { n: "Registro en plataforma CE", d: 10 },
      { n: "Valoracion del estado general", d: 15 },
    ],
  },
  "Alimentacion": {
    color: "#EA580C",
    bg: "#FFEDD5",
    items: [
      { n: "Preparacion y servicio del alimento", d: 20 },
      { n: "Alimentacion oral asistida", d: 30 },
      { n: "Alimentacion por sonda nasogastrica (SNG)", d: 30 },
      { n: "Alimentacion por gastrostomia PEG", d: 30 },
      { n: "Hidratacion oral asistida", d: 15 },
      { n: "Administracion de suplemento nutricional", d: 10 },
    ],
  },
  "Medicamentos": {
    color: "#7C3AED",
    bg: "#EDE9FE",
    items: [
      { n: "Administracion de medicamentos via oral", d: 10 },
      { n: "Administracion por gastrostomia PEG", d: 15 },
      { n: "Administracion de medicamentos IV", d: 20 },
      { n: "Administracion de medicamentos IM", d: 10 },
      { n: "Administracion de insulina subcutanea", d: 10 },
      { n: "Administracion oftalmica", d: 5 },
      { n: "Nebulizacion / Terapia inhalatoria", d: 15 },
      { n: "Aplicacion de parches transdermicos", d: 5 },
      { n: "Preparacion y verificacion del esquema de medicacion", d: 15 },
    ],
  },
  "Heridas y piel": {
    color: "#DC2626",
    bg: "#FEE2E2",
    items: [
      { n: "Curacion de herida quirurgica", d: 20 },
      { n: "Curacion de ulcera por presion", d: 30 },
      { n: "Curacion de pie diabetico / ulcera diabetica", d: 30 },
      { n: "Cuidado de estoma (colostomia/ileostomia)", d: 20 },
      { n: "Cuidado de cateter PICC", d: 15 },
      { n: "Aplicacion y cambio de vendaje", d: 15 },
      { n: "Masaje terapeutico en zonas de presion", d: 15 },
      { n: "Aplicacion de crema / unguento topico", d: 10 },
    ],
  },
  "Movilizacion": {
    color: "#16A34A",
    bg: "#DCFCE7",
    items: [
      { n: "Cambio de posicion (decubito cada 2 hrs)", d: 10 },
      { n: "Movilizacion pasiva extremidades superiores", d: 15 },
      { n: "Movilizacion pasiva extremidades inferiores", d: 15 },
      { n: "Ejercicios de amplitud de movimiento", d: 20 },
      { n: "Transferencia cama a silla de ruedas", d: 15 },
      { n: "Transferencia silla a cama", d: 15 },
      { n: "Deambulacion asistida", d: 20 },
      { n: "Fisioterapia respiratoria", d: 15 },
      { n: "Posicionamiento terapeutico", d: 10 },
    ],
  },
  "Eliminacion": {
    color: "#CA8A04",
    bg: "#FEF9C3",
    items: [
      { n: "Cambio de panal", d: 10 },
      { n: "Control y medicion de diuresis", d: 10 },
      { n: "Cuidado de sonda Foley", d: 10 },
      { n: "Cambio de bolsa de drenaje urinario", d: 10 },
      { n: "Vaciamiento de bolsa de colostomia", d: 10 },
      { n: "Asistencia para uso de bacinica/comodo", d: 10 },
      { n: "Enema evacuante", d: 20 },
      { n: "Supervision y registro de evacuaciones", d: 5 },
    ],
  },
  "Respiratorio": {
    color: "#0891B2",
    bg: "#CFFAFE",
    items: [
      { n: "Supervision y ajuste de oxigenoterapia", d: 10 },
      { n: "Aspiracion de secreciones", d: 15 },
      { n: "Cuidado de traqueotomia", d: 20 },
      { n: "Nebulizacion", d: 15 },
      { n: "Fisioterapia toracica / Percusion pulmonar", d: 15 },
    ],
  },
  "Procedimientos": {
    color: "#4F46E5",
    bg: "#E0E7FF",
    items: [
      { n: "Instalacion de venoclisis", d: 15 },
      { n: "Administracion de solucion IV", d: 20 },
      { n: "Cuidado y cambio de cateter periferico", d: 15 },
      { n: "Heparinizacion de cateter", d: 10 },
      { n: "Toma de muestra sanguinea", d: 10 },
      { n: "Dialisis peritoneal", d: 45 },
    ],
  },
  "Educacion y apoyo": {
    color: "#DB2777",
    bg: "#FCE7F3",
    items: [
      { n: "Educacion al paciente: diagnostico y tratamiento", d: 20 },
      { n: "Educacion a la familia sobre cuidados en casa", d: 20 },
      { n: "Orientacion a la realidad", d: 10 },
      { n: "Estimulacion cognitiva", d: 20 },
      { n: "Actividades de entretenimiento asistidas", d: 30 },
      { n: "Apoyo emocional y escucha activa", d: 20 },
    ],
  },
  "Seguridad": {
    color: "#6B7280",
    bg: "#F3F4F6",
    items: [
      { n: "Revision del entorno y prevencion de caidas", d: 10 },
      { n: "Supervision general del paciente (rondin)", d: 10 },
      { n: "Orden y limpieza del area de cuidados", d: 10 },
      { n: "Verificacion de barandales y dispositivos de seguridad", d: 5 },
    ],
  },
};

export const DUR_OPTS = [5, 10, 15, 20, 30, 45, 60, 90, 120];

export const EVA_COLORS = [
  "#22C55E", "#4ADE80", "#86EFAC", "#BEF264", "#FDE047",
  "#FBBF24", "#FB923C", "#F87171", "#EF4444", "#DC2626", "#991B1B",
];

export const EVA_TEXT = [
  "Sin dolor", "Sin dolor", "Leve", "Leve", "Moderado",
  "Moderado", "Moderado", "Intenso", "Intenso", "Insoportable", "Insoportable",
];

export const INC_QUESTIONS = {
  caida: "Ocurrio alguna caida?",
  reaccion: "Reaccion adversa a medicamento?",
  dolor: "Crisis de dolor o malestar agudo?",
  svitales: "Cambio brusco en signos vitales?",
  agitacion: "Agitacion o conducta inadecuada?",
  otra: "Otra incidencia relevante?",
};

export const INC_LABELS = {
  caida: "Caida",
  reaccion: "Reaccion adversa",
  dolor: "Crisis de dolor",
  svitales: "Cambio en SV",
  agitacion: "Agitacion",
  otra: "Otra incidencia",
};

export const CONDITIONS = ["Estable", "Con mejoria", "Sin cambios", "Con deterioro"];
export const EMOTIONS = ["Tranquilo/a", "Ansioso/a", "Agitado/a", "Deprimido/a"];

// Alimentacion (cierre)
export const NUTRITION_VIA = ["Oral", "SNG", "PEG", "Parenteral", "NPO (ayuno)"];
export const NUTRITION_TOLERANCE = ["Buena", "Regular", "Mala"];
export const NUTRITION_INTAKE = ["100%", "75%", "50%", "25%", "0%"];
export const NUTRITION_APPETITE = ["Conservado", "Disminuido", "Ausente", "Aumentado"];
export const NUTRITION_DIET = ["Normal", "Blanda", "Liquidos", "Hiposodica", "Diabetica", "Hiperproteica"];

// Racion consumida por tiempo de comida (0 = no comio, 4/4 = todo)
export const MEAL_PORTIONS = ["0", "1/4", "1/2", "3/4", "4/4"];
export const MEAL_TYPES = [
  { key: "breakfast", label: "Desayuno" },
  { key: "lunch", label: "Comida" },
  { key: "dinner", label: "Cena" },
];

// Eliminacion (cierre)
export const URINE_METHOD = ["Espontanea", "Sonda Foley", "Panal", "Comodo"];
export const URINE_APPEARANCE = ["Clara", "Concentrada", "Hematurica", "Turbia"];
export const URINE_VOLUME = ["Normal", "Oliguria", "Poliuria", "Anuria"];
export const STOOL_CONSISTENCY = ["Formada", "Blanda", "Liquida", "Dura"];
export const STOOL_APPEARANCE = ["Normal", "Diarreica", "Estrenimiento", "Melena", "Con sangre"];
export const STOOL_METHOD = ["Espontanea", "Asistida", "Colostomia", "Enema"];
export const URINE_TIMES = ["1-2", "3-4", "5-6", "7+"];
export const STOOL_TIMES = ["1", "2", "3", "4+"];

// Catalogo de materiales mas usados en cuidado de enfermeria
export const MATERIAL_CATALOG = [
  { name: "Panal de adulto", unit: "pz" },
  { name: "Gasas esteriles", unit: "pz" },
  { name: "Guantes esteriles", unit: "par" },
  { name: "Guantes no esteriles", unit: "par" },
  { name: "Toallitas humedas", unit: "pz" },
  { name: "Jeringa 5 ml", unit: "pz" },
  { name: "Jeringa 10 ml", unit: "pz" },
  { name: "Aposito adhesivo", unit: "pz" },
  { name: "Suero fisiologico", unit: "ml" },
  { name: "Sonda nasogastrica", unit: "pz" },
  { name: "Sonda Foley", unit: "pz" },
  { name: "Cateter IV", unit: "pz" },
  { name: "Cubrebocas", unit: "pz" },
  { name: "Bolsa colostomia", unit: "pz" },
  { name: "Cinta micropore", unit: "rollo" },
  { name: "Banda elastica", unit: "pz" },
  { name: "Alcohol antiseptico", unit: "ml" },
  { name: "Algodon", unit: "g" },
];

// Escala de heces de Bristol (7 tipos). Color: rojo=estrenimiento, verde=normal, amarillo/naranja=diarrea.
export const BRISTOL_SCALE = [
  { type: "1", short: "Pelotitas duras",     desc: "Trozos duros separados (estrenimiento severo)", color: "#B91C1C" },
  { type: "2", short: "Salchicha grumosa",   desc: "Forma de salchicha pero a grumos (estrenimiento leve)", color: "#DC2626" },
  { type: "3", short: "Salchicha con grietas", desc: "Salchicha con grietas en la superficie (normal)", color: "#16A34A" },
  { type: "4", short: "Salchicha lisa",      desc: "Salchicha lisa y blanda (normal ideal)", color: "#15803D" },
  { type: "5", short: "Trozos blandos",      desc: "Trozos blandos con bordes definidos (falta fibra)", color: "#CA8A04" },
  { type: "6", short: "Pastosa",             desc: "Trozos blandos y pastosos (diarrea leve)", color: "#EA580C" },
  { type: "7", short: "Liquida",             desc: "Liquidas, sin trozos solidos (diarrea severa)", color: "#DC2626" },
];

// Add a duration to a HH:MM string. Returns HH:MM (rounded).
export function addMinutes(time, minutes) {
  if (!time) return "";
  const [hStr, mStr] = time.split(":");
  const total = parseInt(hStr, 10) * 60 + parseInt(mStr, 10) + Number(minutes || 0);
  const h = Math.floor((total % (24 * 60)) / 60);
  const m = total % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}
